import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

const TermsOfService = () => {
    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <header className="bg-white shadow-sm sticky top-0 z-10">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
                    <Link to="/" className="flex items-center text-gray-600 hover:text-primary transition-colors">
                        <ArrowLeft className="w-5 h-5 mr-2" />
                        Back to Home
                    </Link>
                    <div className="flex items-center space-x-2">
                        <FileText className="w-6 h-6 text-primary" />
                        <span className="font-bold text-gray-900">Terms of Service</span>
                    </div>
                </div>
            </header>

            <main className="flex-grow max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="bg-white shadow-lg rounded-2xl p-8 md:p-12">
                    <h1 className="text-3xl font-bold text-gray-900 mb-6">Terms of Service</h1>
                    <p className="text-gray-500 mb-8">Last updated: January 26, 2025</p>

                    <div className="prose prose-blue max-w-none text-gray-600 space-y-6">
                        <p>
                            Please read these Terms of Service ("Terms") carefully before using the Intuit LMS platform operated by us.
                        </p>

                        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">1. Acceptance of Terms</h2>
                        <p>
                            By accessing or using the Service, you agree to be bound by these Terms. If you disagree with any part of the terms,
                            then you may not access the Service.
                        </p>

                        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">2. Accounts</h2>
                        <p>
                            When you create an account with us, you must provide information that is accurate, complete, and current at all times.
                            Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account.
                        </p>

                        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">3. Intellectual Property</h2>
                        <p>
                            The Service and its original content, features, and functionality are and will remain the exclusive property of Intuit LMS
                            and its licensors.
                        </p>

                        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">4. Content Liability</h2>
                        <p>
                            Our Service allows you to post, link, store, share and otherwise make available certain information, text, graphics, videos,
                            or other material ("Content"). You are responsible for the Content that you post to the Service, including its legality, reliability, and appropriateness.
                        </p>

                        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">5. Termination</h2>
                        <p>
                            We may terminate or suspend access to our Service immediately, without prior notice or liability, for any reason whatsoever,
                            including without limitation if you breach the Terms.
                        </p>
                    </div>
                </div>
            </main>
            <footer className="bg-gray-900 text-white py-8 text-center">
                <p className="text-gray-400">© 2025 INTUIT LMS. All rights reserved.</p>
            </footer>
        </div>
    );
};

export default TermsOfService;
